<template>
  <section class="article">
    <router-link :to="{ name: 'works' }" class="article__back" v-if="back">
      <span>Back</span>
    </router-link>

    <div class="article__content">
      <component
        :is="component.type"
        :key="`component-${index}`"
        :content="component.content"
        v-for="(component, index) in article.components" />
    </div>
  </section>
</template>

<script>
import ContentText from '@blocks/ContentText'
import ContentList from '@blocks/ContentList'
import ContentGallery from '@blocks/ContentGallery'
import ContentVideos from '@blocks/ContentVideos'

export default {
  name: 'TheArticle',
  props: {
    article: {
      type: Object,
      required: true
    },
    back: {
      type: Boolean,
      required: false
    }
  },
  components: {
    ContentText,
    ContentList,
    ContentGallery,
    ContentVideos
  },
  methods: {
    handleClick () {
      this.$router.push({ name: 'works' })
    }
  }
}
</script>

<style lang="scss">
.article{
  @include media("small") {
    padding: layout("spacing") layout("spacing")/2;
  }
  @include media("medium") {
    padding: layout("spacing")*1.5;
  }
  @include media("small-medium"){
    @include add-top-bottom-gradient;
    align-items: flex-start;
  }
  @include media("large"){
    @include add-top-bottom-gradient;
    align-items: flex-end;
    padding: layout("spacing")*4 6rem;
  }

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  position: relative;

  &__content{
    @include media("large"){
      max-width: 60rem;
    }
    width: 100%;
    // padding-bottom: layout("spacing");
  }

  &__back{
    @include media("small-medium"){
      margin-top: layout("spacing")*2;
    }
    @include add-transition;
    @include icon(icons("arrow-left"));

    display: block;
    width: 100%;
    text-decoration: none;
    font-size: 3.5rem;

    position: relative;
    transform: translateY(-1rem);
    margin-bottom: layout("spacing");

    &:hover{
       &::before{
        color: rgba(white, 1);
      }
    }
    span{
      @include hide-visually;
    }

    &::before{
      @include add-transition;
      color: rgba(white, 0.3);
    }
  }
}
</style>
